<template>
  <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick" class="border-tabs vh-140">
    <el-tab-pane label="通用岗位" name="normal">
      <normal-post ref="normalPost"></normal-post>
    </el-tab-pane>
    <el-tab-pane label="企业岗位" name="company">
      <company-post ref="companyPost"></company-post>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import NormalPost from "./NormalPost";
import CompanyPost from "./CompanyPost";

export default {
  name: "question-list",
  components: { NormalPost, CompanyPost },
  created() {
  },
  data: function() {
    return {
      activeName: "normal"
    };
  },
  methods: {
    //切换刷新数据
    handleClick(e) {
      if (e.name === "normal") {
        this.$refs.normalPost.fetchData();
      } else {
        this.$refs.companyPost.fetchData();
      }
    }
  }
};
</script>
<style lang="scss" type="text/scss">
.border-tabs {
  .el-tabs__item {
    position: relative;

    &.is-active {
      position: relative;
      font-weight: 400;
      font-size: 14px;

      &:before {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        width: 100%;
        display: block;
        content: ' ';
        border-top: 3px solid #1890ff;
      }
    }
  }

}
</style>
